module.exports = __webpack_public_path__ + "img/s12.4d8763a7.png";